// Generated by Melange

import * as Buhta_commonapis__Buhta_common_v1_grid from "../../commonapis/gen/buhta_common_v1_grid.js";
import * as Buhta_kassaapis__Buhta_kassa_v1alpha1_receipt from "./buhta_kassa_v1alpha1_receipt.js";
import * as Buhta_kassaapis__Buhta_kassa_v1alpha1_receipt_data from "./buhta_kassa_v1alpha1_receipt_data.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const GetReceiptRequest = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_receipt_service.ml",
      731,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const GetReceiptResponse = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_receipt_service.ml",
      797,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ListReceiptsRequest = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_receipt_service.ml",
      858,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ListReceiptsResponse = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_receipt_service.ml",
      921,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const CreateReceiptRequest = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_receipt_service.ml",
      982,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const CreateReceiptResponse = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_receipt_service.ml",
      1045,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.kassa.v1alpha1.GetReceiptRequest";
}

function make(kkm_idOpt, idOpt, expandOpt, param) {
  const kkm_id = kkm_idOpt !== undefined ? kkm_idOpt : 0;
  const id = idOpt !== undefined ? idOpt : "";
  const expand = expandOpt !== undefined ? expandOpt : /* [] */0;
  return {
          kkm_id: kkm_id,
          id: id,
          expand: expand
        };
}

const merge_kkm_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "kkm_id",
            "kkmId"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const merge_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_expand = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            3,
            "expand",
            "expand"
          ],
          Ocaml_protoc_plugin__Spec.string,
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge(t1, t2) {
  return {
          kkm_id: Curry._2(merge_kkm_id, t1.kkm_id, t2.kkm_id),
          id: Curry._2(merge_id, t1.id, t2.id),
          expand: Curry._2(merge_expand, t1.expand, t2.expand)
        };
}

function spec(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "kkm_id",
                    "kkmId"
                  ],
                  Ocaml_protoc_plugin__Spec.int32_int,
                  0
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "id",
                        "id"
                      ],
                      Ocaml_protoc_plugin__Spec.string,
                      ""
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                          [
                            3,
                            "expand",
                            "expand"
                          ],
                          Ocaml_protoc_plugin__Spec.string,
                          Ocaml_protoc_plugin__Spec.not_packed
                        ]), Ocaml_protoc_plugin__Spec.nil)));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry._4(serialize, writer, param.kkm_id, param.id, param.expand);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(kkm_id, id, expand) {
  return {
          kkm_id: kkm_id,
          id: id,
          expand: expand
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.GetReceiptRequest", spec(undefined))(options);
  return function (param) {
    return Curry._3(serialize, param.kkm_id, param.id, param.expand);
  };
}

function constructor$1(kkm_id, id, expand) {
  return {
          kkm_id: kkm_id,
          id: id,
          expand: expand
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.GetReceiptRequest", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, GetReceiptRequest, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

function name$1(param) {
  return ".buhta.kassa.v1alpha1.GetReceiptResponse";
}

function make$1(receipt, param) {
  return {
          receipt: receipt
        };
}

const $$let = Buhta_kassaapis__Buhta_kassa_v1alpha1_receipt.Buhta.Kassa.V1alpha1.Receipt;

const merge_receipt = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "receipt",
            "receipt"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let.name,
                make: $$let.make,
                from_proto: $$let.from_proto,
                from_proto_exn: $$let.from_proto_exn,
                to_proto: $$let.to_proto,
                to_proto$p: $$let.to_proto$p,
                merge: $$let.merge,
                to_json: $$let.to_json,
                from_json_exn: $$let.from_json_exn,
                from_json: $$let.from_json
              })
        ]));

function merge$1(t1, t2) {
  return {
          receipt: Curry._2(merge_receipt, t1.receipt, t2.receipt)
        };
}

function spec$1(param) {
  const $$let = Buhta_kassaapis__Buhta_kassa_v1alpha1_receipt.Buhta.Kassa.V1alpha1.Receipt;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "receipt",
                    "receipt"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
    });

function to_proto$p$1(writer, param) {
  Curry._2(serialize$1, writer, param.receipt);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2(receipt) {
  return {
          receipt: receipt
        };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
    });

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$1, writer);
            });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.GetReceiptResponse", spec$1(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.receipt);
  };
}

function constructor$3(receipt) {
  return {
          receipt: receipt
        };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.GetReceiptResponse", spec$1(undefined), constructor$3);
    });

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$1, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, GetReceiptResponse, {
      make: make$1,
      to_proto: to_proto$1,
      from_proto: from_proto$1,
      to_json: to_json$1,
      from_json: from_json$1,
      name: name$1,
      merge: merge$1,
      to_proto$p: to_proto$p$1,
      from_proto_exn: from_proto_exn$1,
      from_json_exn: from_json_exn$1
    });

function name$2(param) {
  return ".buhta.kassa.v1alpha1.ListReceiptsRequest";
}

function make$2(kkm_idOpt, grid, param) {
  const kkm_id = kkm_idOpt !== undefined ? kkm_idOpt : 0;
  return {
          kkm_id: kkm_id,
          grid: grid
        };
}

const merge_kkm_id$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "kkm_id",
            "kkmId"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const $$let$1 = Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest;

const merge_grid = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            2,
            "grid",
            "grid"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$1.name,
                make: $$let$1.make,
                from_proto: $$let$1.from_proto,
                from_proto_exn: $$let$1.from_proto_exn,
                to_proto: $$let$1.to_proto,
                to_proto$p: $$let$1.to_proto$p,
                merge: $$let$1.merge,
                to_json: $$let$1.to_json,
                from_json_exn: $$let$1.from_json_exn,
                from_json: $$let$1.from_json
              })
        ]));

function merge$2(t1, t2) {
  return {
          kkm_id: Curry._2(merge_kkm_id$1, t1.kkm_id, t2.kkm_id),
          grid: Curry._2(merge_grid, t1.grid, t2.grid)
        };
}

function spec$2(param) {
  const $$let = Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "kkm_id",
                    "kkmId"
                  ],
                  Ocaml_protoc_plugin__Spec.int32_int,
                  0
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                      [
                        2,
                        "grid",
                        "grid"
                      ],
                      Ocaml_protoc_plugin__Spec.message({
                            name: $$let.name,
                            make: $$let.make,
                            from_proto: $$let.from_proto,
                            from_proto_exn: $$let.from_proto_exn,
                            to_proto: $$let.to_proto,
                            to_proto$p: $$let.to_proto$p,
                            merge: $$let.merge,
                            to_json: $$let.to_json,
                            from_json_exn: $$let.from_json_exn,
                            from_json: $$let.from_json
                          })
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$2(undefined));
    });

function to_proto$p$2(writer, param) {
  Curry._3(serialize$2, writer, param.kkm_id, param.grid);
}

function to_proto$2(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$2(writer, t);
  return writer;
}

function constructor$4(kkm_id, grid) {
  return {
          kkm_id: kkm_id,
          grid: grid
        };
}

const from_proto_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$2(undefined), constructor$4);
    });

function from_proto$2(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$2, writer);
            });
}

function to_json$2(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.ListReceiptsRequest", spec$2(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.kkm_id, param.grid);
  };
}

function constructor$5(kkm_id, grid) {
  return {
          kkm_id: kkm_id,
          grid: grid
        };
}

const from_json_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.ListReceiptsRequest", spec$2(undefined), constructor$5);
    });

function from_json$2(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$2, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ListReceiptsRequest, {
      make: make$2,
      to_proto: to_proto$2,
      from_proto: from_proto$2,
      to_json: to_json$2,
      from_json: from_json$2,
      name: name$2,
      merge: merge$2,
      to_proto$p: to_proto$p$2,
      from_proto_exn: from_proto_exn$2,
      from_json_exn: from_json_exn$2
    });

function name$3(param) {
  return ".buhta.kassa.v1alpha1.ListReceiptsResponse";
}

function make$3(receiptsOpt, param) {
  const receipts = receiptsOpt !== undefined ? receiptsOpt : /* [] */0;
  return {
          receipts: receipts
        };
}

const $$let$2 = Buhta_kassaapis__Buhta_kassa_v1alpha1_receipt.Buhta.Kassa.V1alpha1.Receipt;

const merge_receipts = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            1,
            "receipts",
            "receipts"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$2.name,
                make: $$let$2.make,
                from_proto: $$let$2.from_proto,
                from_proto_exn: $$let$2.from_proto_exn,
                to_proto: $$let$2.to_proto,
                to_proto$p: $$let$2.to_proto$p,
                merge: $$let$2.merge,
                to_json: $$let$2.to_json,
                from_json_exn: $$let$2.from_json_exn,
                from_json: $$let$2.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge$3(t1, t2) {
  return {
          receipts: Curry._2(merge_receipts, t1.receipts, t2.receipts)
        };
}

function spec$3(param) {
  const $$let = Buhta_kassaapis__Buhta_kassa_v1alpha1_receipt.Buhta.Kassa.V1alpha1.Receipt;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                  [
                    1,
                    "receipts",
                    "receipts"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      }),
                  Ocaml_protoc_plugin__Spec.not_packed
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$3(undefined));
    });

function to_proto$p$3(writer, param) {
  Curry._2(serialize$3, writer, param.receipts);
}

function to_proto$3(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$3(writer, t);
  return writer;
}

function constructor$6(receipts) {
  return {
          receipts: receipts
        };
}

const from_proto_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$3(undefined), constructor$6);
    });

function from_proto$3(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$3, writer);
            });
}

function to_json$3(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.ListReceiptsResponse", spec$3(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.receipts);
  };
}

function constructor$7(receipts) {
  return {
          receipts: receipts
        };
}

const from_json_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.ListReceiptsResponse", spec$3(undefined), constructor$7);
    });

function from_json$3(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$3, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ListReceiptsResponse, {
      make: make$3,
      to_proto: to_proto$3,
      from_proto: from_proto$3,
      to_json: to_json$3,
      from_json: from_json$3,
      name: name$3,
      merge: merge$3,
      to_proto$p: to_proto$p$3,
      from_proto_exn: from_proto_exn$3,
      from_json_exn: from_json_exn$3
    });

function name$4(param) {
  return ".buhta.kassa.v1alpha1.CreateReceiptRequest";
}

function make$4(kkm_idOpt, receipt, param) {
  const kkm_id = kkm_idOpt !== undefined ? kkm_idOpt : 0;
  return {
          kkm_id: kkm_id,
          receipt: receipt
        };
}

const merge_kkm_id$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "kkm_id",
            "kkmId"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const $$let$3 = Buhta_kassaapis__Buhta_kassa_v1alpha1_receipt_data.Buhta.Kassa.V1alpha1.ReceiptData;

const merge_receipt$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            2,
            "receipt",
            "receipt"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$3.name,
                make: $$let$3.make,
                from_proto: $$let$3.from_proto,
                from_proto_exn: $$let$3.from_proto_exn,
                to_proto: $$let$3.to_proto,
                to_proto$p: $$let$3.to_proto$p,
                merge: $$let$3.merge,
                to_json: $$let$3.to_json,
                from_json_exn: $$let$3.from_json_exn,
                from_json: $$let$3.from_json
              })
        ]));

function merge$4(t1, t2) {
  return {
          kkm_id: Curry._2(merge_kkm_id$2, t1.kkm_id, t2.kkm_id),
          receipt: Curry._2(merge_receipt$1, t1.receipt, t2.receipt)
        };
}

function spec$4(param) {
  const $$let = Buhta_kassaapis__Buhta_kassa_v1alpha1_receipt_data.Buhta.Kassa.V1alpha1.ReceiptData;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "kkm_id",
                    "kkmId"
                  ],
                  Ocaml_protoc_plugin__Spec.int32_int,
                  0
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                      [
                        2,
                        "receipt",
                        "receipt"
                      ],
                      Ocaml_protoc_plugin__Spec.message({
                            name: $$let.name,
                            make: $$let.make,
                            from_proto: $$let.from_proto,
                            from_proto_exn: $$let.from_proto_exn,
                            to_proto: $$let.to_proto,
                            to_proto$p: $$let.to_proto$p,
                            merge: $$let.merge,
                            to_json: $$let.to_json,
                            from_json_exn: $$let.from_json_exn,
                            from_json: $$let.from_json
                          })
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$4(undefined));
    });

function to_proto$p$4(writer, param) {
  Curry._3(serialize$4, writer, param.kkm_id, param.receipt);
}

function to_proto$4(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$4(writer, t);
  return writer;
}

function constructor$8(kkm_id, receipt) {
  return {
          kkm_id: kkm_id,
          receipt: receipt
        };
}

const from_proto_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$4(undefined), constructor$8);
    });

function from_proto$4(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$4, writer);
            });
}

function to_json$4(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.CreateReceiptRequest", spec$4(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.kkm_id, param.receipt);
  };
}

function constructor$9(kkm_id, receipt) {
  return {
          kkm_id: kkm_id,
          receipt: receipt
        };
}

const from_json_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.CreateReceiptRequest", spec$4(undefined), constructor$9);
    });

function from_json$4(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$4, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, CreateReceiptRequest, {
      make: make$4,
      to_proto: to_proto$4,
      from_proto: from_proto$4,
      to_json: to_json$4,
      from_json: from_json$4,
      name: name$4,
      merge: merge$4,
      to_proto$p: to_proto$p$4,
      from_proto_exn: from_proto_exn$4,
      from_json_exn: from_json_exn$4
    });

function name$5(param) {
  return ".buhta.kassa.v1alpha1.CreateReceiptResponse";
}

function make$5(receipt, param) {
  return {
          receipt: receipt
        };
}

const $$let$4 = Buhta_kassaapis__Buhta_kassa_v1alpha1_receipt.Buhta.Kassa.V1alpha1.Receipt;

const merge_receipt$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "receipt",
            "receipt"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$4.name,
                make: $$let$4.make,
                from_proto: $$let$4.from_proto,
                from_proto_exn: $$let$4.from_proto_exn,
                to_proto: $$let$4.to_proto,
                to_proto$p: $$let$4.to_proto$p,
                merge: $$let$4.merge,
                to_json: $$let$4.to_json,
                from_json_exn: $$let$4.from_json_exn,
                from_json: $$let$4.from_json
              })
        ]));

function merge$5(t1, t2) {
  return {
          receipt: Curry._2(merge_receipt$2, t1.receipt, t2.receipt)
        };
}

function spec$5(param) {
  const $$let = Buhta_kassaapis__Buhta_kassa_v1alpha1_receipt.Buhta.Kassa.V1alpha1.Receipt;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "receipt",
                    "receipt"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$5(undefined));
    });

function to_proto$p$5(writer, param) {
  Curry._2(serialize$5, writer, param.receipt);
}

function to_proto$5(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$5(writer, t);
  return writer;
}

function constructor$10(receipt) {
  return {
          receipt: receipt
        };
}

const from_proto_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$5(undefined), constructor$10);
    });

function from_proto$5(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$5, writer);
            });
}

function to_json$5(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.CreateReceiptResponse", spec$5(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.receipt);
  };
}

function constructor$11(receipt) {
  return {
          receipt: receipt
        };
}

const from_json_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.CreateReceiptResponse", spec$5(undefined), constructor$11);
    });

function from_json$5(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$5, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, CreateReceiptResponse, {
      make: make$5,
      to_proto: to_proto$5,
      from_proto: from_proto$5,
      to_json: to_json$5,
      from_json: from_json$5,
      name: name$5,
      merge: merge$5,
      to_proto$p: to_proto$p$5,
      from_proto_exn: from_proto_exn$5,
      from_json_exn: from_json_exn$5
    });

const getReceipt_0 = {
  name: GetReceiptRequest.name,
  make: GetReceiptRequest.make,
  from_proto: GetReceiptRequest.from_proto,
  from_proto_exn: GetReceiptRequest.from_proto_exn,
  to_proto: GetReceiptRequest.to_proto,
  to_proto$p: GetReceiptRequest.to_proto$p,
  merge: GetReceiptRequest.merge,
  to_json: GetReceiptRequest.to_json,
  from_json_exn: GetReceiptRequest.from_json_exn,
  from_json: GetReceiptRequest.from_json
};

const getReceipt_1 = {
  name: GetReceiptResponse.name,
  make: GetReceiptResponse.make,
  from_proto: GetReceiptResponse.from_proto,
  from_proto_exn: GetReceiptResponse.from_proto_exn,
  to_proto: GetReceiptResponse.to_proto,
  to_proto$p: GetReceiptResponse.to_proto$p,
  merge: GetReceiptResponse.merge,
  to_json: GetReceiptResponse.to_json,
  from_json_exn: GetReceiptResponse.from_json_exn,
  from_json: GetReceiptResponse.from_json
};

const getReceipt = [
  getReceipt_0,
  getReceipt_1
];

const listReceipts_0 = {
  name: ListReceiptsRequest.name,
  make: ListReceiptsRequest.make,
  from_proto: ListReceiptsRequest.from_proto,
  from_proto_exn: ListReceiptsRequest.from_proto_exn,
  to_proto: ListReceiptsRequest.to_proto,
  to_proto$p: ListReceiptsRequest.to_proto$p,
  merge: ListReceiptsRequest.merge,
  to_json: ListReceiptsRequest.to_json,
  from_json_exn: ListReceiptsRequest.from_json_exn,
  from_json: ListReceiptsRequest.from_json
};

const listReceipts_1 = {
  name: ListReceiptsResponse.name,
  make: ListReceiptsResponse.make,
  from_proto: ListReceiptsResponse.from_proto,
  from_proto_exn: ListReceiptsResponse.from_proto_exn,
  to_proto: ListReceiptsResponse.to_proto,
  to_proto$p: ListReceiptsResponse.to_proto$p,
  merge: ListReceiptsResponse.merge,
  to_json: ListReceiptsResponse.to_json,
  from_json_exn: ListReceiptsResponse.from_json_exn,
  from_json: ListReceiptsResponse.from_json
};

const listReceipts = [
  listReceipts_0,
  listReceipts_1
];

const createReceipt_0 = {
  name: CreateReceiptRequest.name,
  make: CreateReceiptRequest.make,
  from_proto: CreateReceiptRequest.from_proto,
  from_proto_exn: CreateReceiptRequest.from_proto_exn,
  to_proto: CreateReceiptRequest.to_proto,
  to_proto$p: CreateReceiptRequest.to_proto$p,
  merge: CreateReceiptRequest.merge,
  to_json: CreateReceiptRequest.to_json,
  from_json_exn: CreateReceiptRequest.from_json_exn,
  from_json: CreateReceiptRequest.from_json
};

const createReceipt_1 = {
  name: CreateReceiptResponse.name,
  make: CreateReceiptResponse.make,
  from_proto: CreateReceiptResponse.from_proto,
  from_proto_exn: CreateReceiptResponse.from_proto_exn,
  to_proto: CreateReceiptResponse.to_proto,
  to_proto$p: CreateReceiptResponse.to_proto$p,
  merge: CreateReceiptResponse.merge,
  to_json: CreateReceiptResponse.to_json,
  from_json_exn: CreateReceiptResponse.from_json_exn,
  from_json: CreateReceiptResponse.from_json
};

const createReceipt = [
  createReceipt_0,
  createReceipt_1
];

const V1alpha1_ReceiptService = {
  GetReceipt: {
    name: "/buhta.kassa.v1alpha1.ReceiptService/GetReceipt",
    package_name: "buhta.kassa.v1alpha1",
    service_name: "ReceiptService",
    method_name: "GetReceipt",
    $$Request: {
      name: GetReceiptRequest.name,
      make: GetReceiptRequest.make,
      from_proto: GetReceiptRequest.from_proto,
      from_proto_exn: GetReceiptRequest.from_proto_exn,
      to_proto: GetReceiptRequest.to_proto,
      to_proto$p: GetReceiptRequest.to_proto$p,
      merge: GetReceiptRequest.merge,
      to_json: GetReceiptRequest.to_json,
      from_json_exn: GetReceiptRequest.from_json_exn,
      from_json: GetReceiptRequest.from_json
    },
    $$Response: {
      name: GetReceiptResponse.name,
      make: GetReceiptResponse.make,
      from_proto: GetReceiptResponse.from_proto,
      from_proto_exn: GetReceiptResponse.from_proto_exn,
      to_proto: GetReceiptResponse.to_proto,
      to_proto$p: GetReceiptResponse.to_proto$p,
      merge: GetReceiptResponse.merge,
      to_json: GetReceiptResponse.to_json,
      from_json_exn: GetReceiptResponse.from_json_exn,
      from_json: GetReceiptResponse.from_json
    }
  },
  getReceipt: getReceipt,
  ListReceipts: {
    name: "/buhta.kassa.v1alpha1.ReceiptService/ListReceipts",
    package_name: "buhta.kassa.v1alpha1",
    service_name: "ReceiptService",
    method_name: "ListReceipts",
    $$Request: {
      name: ListReceiptsRequest.name,
      make: ListReceiptsRequest.make,
      from_proto: ListReceiptsRequest.from_proto,
      from_proto_exn: ListReceiptsRequest.from_proto_exn,
      to_proto: ListReceiptsRequest.to_proto,
      to_proto$p: ListReceiptsRequest.to_proto$p,
      merge: ListReceiptsRequest.merge,
      to_json: ListReceiptsRequest.to_json,
      from_json_exn: ListReceiptsRequest.from_json_exn,
      from_json: ListReceiptsRequest.from_json
    },
    $$Response: {
      name: ListReceiptsResponse.name,
      make: ListReceiptsResponse.make,
      from_proto: ListReceiptsResponse.from_proto,
      from_proto_exn: ListReceiptsResponse.from_proto_exn,
      to_proto: ListReceiptsResponse.to_proto,
      to_proto$p: ListReceiptsResponse.to_proto$p,
      merge: ListReceiptsResponse.merge,
      to_json: ListReceiptsResponse.to_json,
      from_json_exn: ListReceiptsResponse.from_json_exn,
      from_json: ListReceiptsResponse.from_json
    }
  },
  listReceipts: listReceipts,
  CreateReceipt: {
    name: "/buhta.kassa.v1alpha1.ReceiptService/CreateReceipt",
    package_name: "buhta.kassa.v1alpha1",
    service_name: "ReceiptService",
    method_name: "CreateReceipt",
    $$Request: {
      name: CreateReceiptRequest.name,
      make: CreateReceiptRequest.make,
      from_proto: CreateReceiptRequest.from_proto,
      from_proto_exn: CreateReceiptRequest.from_proto_exn,
      to_proto: CreateReceiptRequest.to_proto,
      to_proto$p: CreateReceiptRequest.to_proto$p,
      merge: CreateReceiptRequest.merge,
      to_json: CreateReceiptRequest.to_json,
      from_json_exn: CreateReceiptRequest.from_json_exn,
      from_json: CreateReceiptRequest.from_json
    },
    $$Response: {
      name: CreateReceiptResponse.name,
      make: CreateReceiptResponse.make,
      from_proto: CreateReceiptResponse.from_proto,
      from_proto_exn: CreateReceiptResponse.from_proto_exn,
      to_proto: CreateReceiptResponse.to_proto,
      to_proto$p: CreateReceiptResponse.to_proto$p,
      merge: CreateReceiptResponse.merge,
      to_json: CreateReceiptResponse.to_json,
      from_json_exn: CreateReceiptResponse.from_json_exn,
      from_json: CreateReceiptResponse.from_json
    }
  },
  createReceipt: createReceipt
};

const V1alpha1 = {
  GetReceiptRequest: GetReceiptRequest,
  GetReceiptResponse: GetReceiptResponse,
  ListReceiptsRequest: ListReceiptsRequest,
  ListReceiptsResponse: ListReceiptsResponse,
  CreateReceiptRequest: CreateReceiptRequest,
  CreateReceiptResponse: CreateReceiptResponse,
  ReceiptService: V1alpha1_ReceiptService
};

const Kassa = {
  V1alpha1: V1alpha1
};

const Buhta = {
  Kassa: Kassa
};

export {
  Imported$pmodules ,
  Buhta ,
}
/* GetReceiptRequest Not a pure module */
